/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_DescInputs */

const en_options_cli_desc = /** @type {(inputs: Options_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure command-line tools for enhanced workflows`)
};

const fr_options_cli_desc = /** @type {(inputs: Options_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurer des outils en ligne de commande pour des flux de travail améliorés`)
};

const de_options_cli_desc = /** @type {(inputs: Options_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurieren Sie Befehlszeilentools für optimierte Arbeitsabläufe`)
};

const it_options_cli_desc = /** @type {(inputs: Options_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurare gli strumenti della riga di comando per flussi di lavoro migliorati`)
};

const ru_options_cli_desc = /** @type {(inputs: Options_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройка инструментов командной строки для повышения эффективности рабочих процессов.`)
};

const es_options_cli_desc = /** @type {(inputs: Options_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurar herramientas de línea de comandos para flujos de trabajo mejorados`)
};

const zh_cn2_options_cli_desc = /** @type {(inputs: Options_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配置命令行工具以增强工作流程`)
};

const ja_options_cli_desc = /** @type {(inputs: Options_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`強化されたワークフローのためのコマンドラインツールを構成する`)
};

const hi_options_cli_desc = /** @type {(inputs: Options_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बेहतर वर्कफ़्लो के लिए कमांड-लाइन टूल कॉन्फ़िगर करें`)
};

const pt_pt2_options_cli_desc = /** @type {(inputs: Options_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure ferramentas de linha de comando para fluxos de trabalho aprimorados.`)
};

/**
* | output |
* | --- |
* | "Configure command-line tools for enhanced workflows" |
*
* @param {Options_Cli_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_desc = /** @type {((inputs?: Options_Cli_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_desc(inputs)
	if (locale === "de") return de_options_cli_desc(inputs)
	if (locale === "it") return it_options_cli_desc(inputs)
	if (locale === "ru") return ru_options_cli_desc(inputs)
	if (locale === "es") return es_options_cli_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_desc(inputs)
	if (locale === "ja") return ja_options_cli_desc(inputs)
	if (locale === "hi") return hi_options_cli_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_desc(inputs)
	return en_options_cli_desc(inputs)
});